import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroTomador from '../../actions/cteos/tomador/adicionarFiltroTomador'
import removerFiltroTomador from '../../actions/cteos/tomador/removerFiltroTomador'
import FiltroBuscaTomador from './FiltroBuscaTomador'
import { FILTRO_NOME, FILTRO_CPF_CNPJ } from '../../util/filtros'

export class FiltroTomador extends Component {
  render () {
    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaTomador
            filtro={FILTRO_NOME}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscaTomador
            filtro={FILTRO_CPF_CNPJ}
            opcoes={[]}
            isNome={true}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosTomador,
  empresaSelecionada: state.empresaSelecionada,
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroTomador,
    removerFiltroTomador,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroTomador)
